import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { IdOrientation } from "../../constants/IdOrientation";
import { utilGrid } from "../../utils/grid/utilGrid";
import { utilBuildings } from "../../utils/utilBuildings";
import { BF2CreateAsset } from "../BF2BuildingGraphicsUtils";
export var GetFencePillarIso = function (data, orientation, baseSetup) {
    var level = utilBuildings.getVisualLevel(data);
    var config = artConfigBuildings["fencePillar_" + level];
    var sprite = BF2CreateAsset(config.assets[0], false);
    sprite.name = "Fence Pillar [" + orientation + "]";
    switch (orientation) {
        case IdOrientation.Left:
            sprite.scale.x *= -1;
            var leftPos = utilGrid.mapToScreen(0, baseSetup.expansionsSizeY);
            sprite.x += leftPos.x;
            sprite.y += leftPos.y;
            break;
        case IdOrientation.Right:
            sprite.scale.x *= -1;
            var rightPos = utilGrid.mapToScreen(baseSetup.expansionsSizeX, baseSetup.expansionsSizeY);
            sprite.x += rightPos.x;
            sprite.y += rightPos.y;
            break;
        case IdOrientation.Up:
            var upPos = utilGrid.mapToScreen(baseSetup.expansionsSizeX, baseSetup.expansionsSizeY);
            sprite.x += upPos.x;
            sprite.y += upPos.y;
            break;
        case IdOrientation.Down:
            var downPos = utilGrid.mapToScreen(baseSetup.expansionsSizeX, 0);
            sprite.x += downPos.x;
            sprite.y += downPos.y;
            break;
    }
    return sprite;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/fence/GetFencePillarIso.ts
// module id = 2217
// module chunks = 3